import Vue from 'vue'
import CheckboxRadio from 'vue-checkbox-radio'

Vue.use(CheckboxRadio)

export default Vue
